import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { bootstrapSession } from '@/api/client';
import { queryClient } from '@/api/query-client';
import { router } from '@/router';
import { useAuthStore } from '@/stores/auth-store';
import '@pixlide/ui/src/styles.css';

/**
 * Restauration de session au démarrage — même mécanique que `frontend/src/main.tsx` : le
 * jeton d'accès vit en mémoire, il est donc perdu à chaque rechargement. On tente
 * immédiatement `/auth/refresh`, dont le cookie HttpOnly est envoyé automatiquement par le
 * navigateur.
 */
async function bootstrap(): Promise<void> {
  try {
    await bootstrapSession();
  } finally {
    useAuthStore.getState().markBootstrapped();
  }
}

const container = document.getElementById('root');

if (container === null) {
  throw new Error("L'élément racine #root est absent du document.");
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);

void bootstrap();
